import { render, staticRenderFns } from "./ccbUnionConfigure.vue?vue&type=template&id=57957e56&scoped=true&"
import script from "./ccbUnionConfigure.vue?vue&type=script&lang=js&"
export * from "./ccbUnionConfigure.vue?vue&type=script&lang=js&"
import style0 from "./ccbUnionConfigure.vue?vue&type=style&index=0&id=57957e56&scoped=true&lang=css&"
import style1 from "./ccbUnionConfigure.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57957e56",
  null
  
)

export default component.exports